export default function InfoContent ( dealer, brand = null, microcopy = null, dealersMapSettings = null, referrerProduct = '', referrerProductID = '' ) {
	return `
	<article role="article" class="hhdealers__result">
	<div class="hhdealers__result__inner">
		<div class="hhdealers__result__inner__top">
			<h3>${ dealer.name }</h3>
			<div class="hhdealers__result__address">
				<span class="hhdealers__result__address__streetAddress">${ dealer.dealer_streetaddress }</span>, 
				<span class="hhdealers__result__address__postalCode">${ dealer.dealer_postalcode }</span> 
				<span class="hhdealers__result__address__addressLocality">${ dealer.dealer_locality }</span>
			</div>

			<div class="hhdealers__result__phone">
				<span class="hhdealers__result__telephone"><a href="tel:${ getFormattedPhone( dealer, dealersMapSettings ) }">${ dealer.dealer_telephone }</a></span>
			</div>
		</div>

		<div class="hhdealers__result__inner__bottom">
			<div class="hhdealers__result__brands">
				<ul class="hhdealers__result__brandslist">
				${ getBrands( dealer ) }
				</ul>
			</div>

			<ul class="hhdealers__result__ctas">
				<li><a class="hhdealers__result__cta hhdealers__result__cta--contact" href="${ getContact( dealer, brand, dealersMapSettings.contact_page_url, referrerProduct, referrerProductID ) }">${ microcopy.dealer_copy_label_contact }</a></li>
				<li><a class="hhdealers__result__cta hhdealers__result__cta--route" href="https://www.google.com/maps/dir/?api=1&destination=${ encodeURIComponent( getDirectionsQuery( dealer ) ) }" target="_blank">${ microcopy.dealer_copy_label_directions }</a></li>
			</ul>
		</div>

	</div>
</article>
	`
}

export const getBrands = ( dealer ) => {
	let liStr = ''
	dealer.brands.forEach( ( brand ) => {
		const liClass = brand.pro === true ? 
			'hhdealers__result__brandslist__item hhdealers__result__brandslist__item__pro' :
			'hhdealers__result__brandslist__item'
		liStr += `
			<li class="${ liClass }" }>
				${ brand.name }
			</li>	
		`
	} )
	return liStr
}

export const getContact = ( dealer, brand, baseURL, referrerProduct, referrerProductID ) => {
	// const baseURL = ''
	// const baseURL = dealersMapSettings.contact_page_url
	const prettyBrandName = brand ? dealer.brands.find( ( el ) => {
		return el.slug === brand
	} ).name : ''

	let infoFormVars =  {
		info_brand : encodeURIComponent( prettyBrandName ),
		dealer_info : encodeURIComponent( `${ dealer.name }, ${ dealer.dealer_streetaddress }, ${ dealer.dealer_postalcode } ${ dealer.dealer_locality }` ),
		dealer_email : encodeURIComponent( dealer.dealer_email )
	}
	if ( referrerProduct !== '' ) {
		infoFormVars.info_product = encodeURIComponent( referrerProduct )
	}
	if ( referrerProductID !== '' ) {
		infoFormVars.url_product = referrerProductID
	}

	let infoFormQueryString = baseURL + '?'
	for ( const [key, value] of Object.entries( infoFormVars ) ) {
		infoFormQueryString += `${ key }=${ value }&`
	}
	return infoFormQueryString.slice( 0, infoFormQueryString.length - 1 )
}

export const getDirectionsQuery = ( dealer ) => {
	return `${ dealer.dealer_streetaddress },${dealer.dealer_postalcode} ${ dealer.dealer_locality }`
}

export const getFormattedPhone = ( dealer, dealersMapSettings ) => {
	let phone = dealer.dealer_telephone
	let formattedPhone = phone.replace( /[.\-+ /]/g, '' )
	if ( formattedPhone.match( /^00.*/ ) !== null ) {
		return `+${ formattedPhone }`
	} else {
		if ( dealersMapSettings && dealersMapSettings.country_code === 'nl' ) {
			return formattedPhone.replace( /^0(.*)/, `+31$1` )
		} else {
			return formattedPhone.replace( /^0(.*)/, `+32$1` )
		}
	}

}